module.exports = __webpack_public_path__ + "img/footer-gzh.e01e45f4.jpg";